<div class="flex-container" [ngStyle]="{ 'display': loader ? 'block' : 'none' }" *ngIf="loader">
  <div class="container-fluid">
    <app-waiting [bg]="'transparent'"></app-waiting>
  </div>
</div>
<section class="section-wrapper" *ngIf="!loader">
  <h2 class="cam-heading">{{dynamicContent?.['b2b.managetraveler.travelermanagement'] | titlecase}} </h2>


  <div class="f-col main-content">
    <!-- Table -->
    <div class="f-row filter-row">
      <div class="component-search">
        <input [placeholder]="dynamicContent?.['b2b.managetraveler.searchbyemploy']" name="search"
          [(ngModel)]="searchString" autocomplete="off" data-dd-privacy="mask" (keydown.enter)="SearchQuery()">
        <span class="f-row">
          <button type="button" class="button-as-span material-symbols-outlined cursor-pointer" *ngIf="!!searchString"
            (click)="refreshData()"><span class="material-symbols-outlined">close</span></button>
          <button type="button" class="button-as-span" aria-label="Search" (click)="SearchQuery()">
            <mat-icon fontSet="material-symbols-outlined" class="search-icon"> search </mat-icon>
          </button>
        </span>
      </div>

      <div class="sorting">
        <div class="filter-block">
          <button type="button" class="button-as-span label-filter" (click)="openFilter(filterModel)">
            {{dynamicContent?.['b2b.managetraveler.filter']}} <mat-icon
              fontSet="material-symbols-outlined">keyboard_arrow_down</mat-icon></button>
        </div>
        <mat-form-field class="selection-filter">
          <label class="mat-label" for=""
            (click)="callByGttm()">{{dynamicContent?.['b2b.managetraveler.sortby']}}</label>
          <mat-select class="sort-flight-filter" [(value)]="selected">
            <mat-option [value]="item?.Phrase" (keydown.enter)="SelectedOrder(item?.Phrase)"
              (keyup.space)="SelectedOrder(item?.Phrase)" (click)="SelectedOrder(item?.Phrase)"
              *ngFor="let item of dynamicContent?.['b2b.managetraveler.sortbydropdown']">{{item?.Phrase}}</mat-option>
            <mat-option value="A-Z" (keydown.enter)="SelectedOrder('A-Z')" (keyup.space)="SelectedOrder('A-Z')"
              (click)="SelectedOrder('A-Z')">{{content?.['b2b.managetraveler.azdropdown']?.[0]?.Phrase ||
              'A-Z'}}</mat-option>
            <mat-option value="Z-A" (keydown.enter)="SelectedOrder('Z-A')" (keyup.space)="SelectedOrder('Z-A')"
              (click)="SelectedOrder('Z-A')">{{content?.['b2b.managetraveler.azdropdown']?.[1]?.Phrase ||
              'Z-A'}}</mat-option>
          </mat-select>
          <mat-icon fontSet="material-symbols-outlined" matSuffix (click)="callByGttm()"> swap_vert </mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="mb-4"></div>
    <div class="section-table data-listing">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
        <!-- Row ID Column -->
        <ng-container matColumnDef="rowid">
          <th mat-header-cell *matHeaderCellDef>{{dynamicContent?.['b2b.managetraveler.rowid']}} </th>
          <td mat-cell *matCellDef="let element"> {{ element.rowid }} </td>
        </ng-container>

        <ng-container matColumnDef="employeeCode">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.employcode']}} </th>
          <td mat-cell *matCellDef="let element" [title]="element.Employee_Code" data-dd-privacy="mask">
            {{ _CommonService.ellipsizeString(element.Employee_Code)}}
          </td>
        </ng-container>

        <ng-container matColumnDef="employeeName">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.employname']}} </th>
          <td mat-cell *matCellDef="let element" [class.td-disabled]="element.User_Status === 2" data-dd-privacy="mask">
            <a tabindex="0" role="button" class="primary-link link cursor-pointer"
              (click)="viewEmployeeDetails(element.SA_User_ID,element.GUID)"
              [title]="element.User_FirstName +' '+ element.User_LastName">
              {{ _CommonService.ellipsizeString(element.User_FirstName +" "+ element.User_LastName) }}
            </a>
          </td>
        </ng-container>

        <!-- User Name Column -->
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.emailaddress']}} </th>
          <td mat-cell *matCellDef="let element" [title]="element.Email_Address" data-dd-privacy="mask"> {{
            _CommonService.ellipsizeString(element.Email_Address)}} </td>
        </ng-container>

        <!-- Branch Name Column -->
        <ng-container matColumnDef="branchName">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.officelocation'] | titlecase}}
          </th>
          <td mat-cell *matCellDef="let element" [title]="element.Branch_Name"> {{ !!element.Branch_Name ?
            _CommonService.ellipsizeString(element.Branch_Name) :'N/A' }} </td>
        </ng-container>

        <!-- Department Column -->
        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.department']}} </th>
          <td mat-cell *matCellDef="let element" [title]="element.Dept_Name"> {{ !!element.Dept_Name ? element.Dept_Name
            : 'N/A' }} </td>
        </ng-container>

        <!-- Phone Number Column -->
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.emerphoneno'] || 'Phone
            Number'}} </th>
          <td mat-cell *matCellDef="let element" [title]="element.Phone_Number" data-dd-privacy="mask"> {{
            !!element.Phone_Number ?
            element.Phone_Number : 'N/A' }} </td>
        </ng-container>

        <!-- Home City Name Column -->
        <ng-container matColumnDef="homeCityName">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.homecity'] || 'Home City'}}
          </th>
          <td mat-cell *matCellDef="let element" [title]="element.Home_CityName" data-dd-privacy="mask"> {{
            !!element.Home_CityName ?
            element.Home_CityName :'N/A' }} </td>
        </ng-container>

        <!-- User Status Column -->
        <ng-container matColumnDef="userStatus">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.userstatus'] | titlecase}} </th>
          <td mat-cell *matCellDef="let element" class="status-tag">
            <span
              [ngClass]="{'status-active': element.User_Status === 1,'status-inactive': element.User_Status === 0,'invite-sent': element.User_Status === 2}">
              {{ element.User_Status == 0 ? 'Deactivated' : element.User_Status == 1 ? 'Active' : element.User_Status ==
              2 ? 'Invite sent' : ''}}</span>
          </td>
        </ng-container>

        <!-- Is VIP Column -->
        <ng-container matColumnDef="isVIP">
          <th mat-header-cell *matHeaderCellDef> VIP </th>
          <td mat-cell *matCellDef="let element">
            {{ element.Is_VIP ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- Is CIP Column -->
        <ng-container matColumnDef="isCIP">
          <th mat-header-cell *matHeaderCellDef> CIP </th>
          <td mat-cell *matCellDef="let element">
            {{ element.Is_CIP ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.managetraveler.actions']}} </th>
          <td mat-cell *matCellDef="let element" class="onclick-links">
            <a tabindex="0" role="button" class="onclick-cell primary-link error-text"
              (keydown.enter)="onDeactivateUser(element, userDeactivateModel)"
              (click)="onDeactivateUser(element, userDeactivateModel)"
              *ngIf="element.User_Status == 1 && !isLoggedInUser(element)">{{dynamicContent?.warningList?.[2]?.confirmCTAText}}</a>
            <a tabindex="0" role="button" class="onclick-cell primary-link" (keydown.enter)="onResendUser(element)"
              (click)="onResendUser(element)"
              *ngIf="element.User_Status == 0 || element.User_Status == 2">{{dynamicContent?.['b2b.managetraveler.resend']
              || 'Resend'}}</a>
            <a *ngIf="(element.User_Status == 1 && isLoggedInUser(element))">&nbsp;</a>
          </td>
        </ng-container>

        <!-- Table Header and Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.table-row-disabled]="row.User_Status==0">
        </tr>

      </table>
    </div>

    <div class="section-table data-listing" *ngIf="!IsShow">
      <app-cam-empty-state [heading]="heading" [content]="content" [IsShow]="IsShow"></app-cam-empty-state>
    </div>

    <div class="f-row more-action justify-center" [style.marginTop.px]="10" *ngIf="IsShow && totalPages > 1">
      <button class="button--prev" (click)="previousPage()" [class.disabled]="pageNumber <= 1">
        <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_left</mat-icon>
      </button>
      <button mat-button class="button--secondary-small">{{ pageNumber < totalPages ? pageNumber : pageNumber
          }}</button>
          <button class="button--next" (click)="nextPage()" [class.disabled]="pageNumber >= totalPages">
            <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_right</mat-icon>
          </button>
    </div>
    <div class="action-listing justify-xs-center" *ngIf="userType == '0'">
      <button mat-button class="button--secondary-small" (click)="openDialog()">
        {{dynamicContent?.['b2b.managetraveler.uploadbulktraveleers'] || 'Upload bulk travelers'}} </button>
      <button mat-button class="button--primary-small" (click)="AddNewTraveler()">
        {{dynamicContent?.['b2b.managetraveler.addnewtraveler']}} </button>
    </div>
  </div>

  <!-- Filter Modal -->
  <ng-template #filterModel>
    <!-- pura form bind -->
    <form [formGroup]="CustomFilter">
      <div class="custom-popup-gen-container">

        <!-- Header -->
        <div class="custom-popup-gen-header">
          <span>{{dynamicContent?.['b2b.managetraveler.filters'] || 'Filters'}}</span>
          <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
            aria-label="Close filter dialog" (click)="filterModalRef.close()" (keydown.enter)="filterModalRef.close()"
            (keydown.space)="filterModalRef.close(); $event.preventDefault()">close</mat-icon>
        </div>

        <!-- Body -->
        <div class="custom-popup-gen-body">

          <!-- Status -->
          <p class="custom-popup-gen-heading">{{dynamicContent?.['b2b.managetraveler.status']}}</p>
          <div class="custom-popup-filter">
            <mat-checkbox formControlName="Active"
              class="checkbox-wrapper">{{dynamicContent?.['b2b.managetraveler.active']}}</mat-checkbox>
            <mat-checkbox formControlName="Deactivated"
              class="checkbox-wrapper">{{dynamicContent?.['b2b.managetraveler.deactivated']}}</mat-checkbox>
          </div>

          <!-- Branch -->
          <p class="custom-popup-gen-heading">{{dynamicContent?.['b2b.managetraveler.officelocation']}}</p>
          <div class="custom-popup-filter" formArrayName="branches">
            <ng-container *ngFor="let branch of branchdata; let i = index">
              <mat-checkbox [formControlName]="i" class="checkbox-wrapper">
                {{ branch.Name }}
              </mat-checkbox>
            </ng-container>
          </div>
        </div>

        <!-- Footer -->
        <div class="custom-popup-gen-footer">
          <button class="button--primary-small" mat-button (click)="applyFilters()"
            [class.disabled]="!CustomFilter.valid">{{dynamicContent?.['b2b.managetraveler.apply'] || 'Apply'}}</button>
        </div>
      </div>
    </form>
  </ng-template>

</section>


<ng-template #userDeactivateModel>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span class="deactivate-popup-title">{{dynamicContent?.warningList?.[2]?.title || 'Are you sure you want to
        deactivate this profile?'}}</span>
    </div>
    <div class="custom-popup-gen-body">
      <p class="custom-popup-gen-text">
        You're about to deactivate
        <span data-dd-privacy="mask">{{selectedTravelerForDeactivation?.User_FirstName}}
          {{selectedTravelerForDeactivation?.User_LastName}}</span>
        profile (Employee Code: <span data-dd-privacy="mask">{{selectedTravelerForDeactivation?.Employee_Code}}</span>).
        Once deactivated, this profile and its data cannot be recovered.
      </p>
    </div>
    <div class="custom-popup-gen-footer">
      <div class="btn-group">
        <button class="button--secondary-small" mat-button
          (click)="cancel(); userDeactivateModellRef.close();">{{dynamicContent?.warningList?.[2]?.cancelCTAText ||
          'Cancel'}}</button>
        <button class="button--primary-small-reject" mat-button
          (click)="onConfirmDeactivateUser()">{{dynamicContent?.warningList?.[2]?.confirmCTAText ||
          'Deactivate'}}</button>
      </div>
    </div>
  </div>
</ng-template>